// получение шаблона элемента проекта
import {DEFAULT_TEMPLATE_CLASS_NAME, tagColors} from "../constants";

export const getProjectTagTemplate = (id: string | undefined, name: string | null): string => {
  return `<li class="tag tag--project" data-id="${id}">${name}
      <button class="tag__remove js-project-remove" aria-label="Удалить проект" type="button"></button>
    </li>`;
};

// Получение шаблона элемента метки
export const getTagTemplate = (color: string, name: string, id: number): string => {
  return `<li class="tags__item tag js-tag" data-id="${id}" style="background-color:${color};">${name}<button class="tag__remove js-tag-remove" data-type="tag" aria-label="Удалить метку" type="button"></button></li>`;
};

// Получение шаблона элемента метки в задаче
export const getTaskTagTemplate = ({color, name, id, type, taskId}): string => {
  return `<li class="tags__item tags__item--${type === `one-task` ? `one` : `create`}-task tag tag--slim js-tag" data-id="${id}" ${
    taskId ? `data-task-id="${taskId}"` : ``
  } data-type="${type}" style="background-color:${color};">${name}<button class="tag__remove js-tag-remove" aria-label="Удалить метку" type="button"></button></li>`;
};

// Получение шаблона элемента проекта
export const getProjectTemplate = (name: string, id: string, isHidden: boolean): string => {
  return `<li class="tags__projects-item" data-id="${id}" ${isHidden ? 'style="display:none;"' : ""}>${name}</li>`;
};

export const getLastMoreProjectElement = (amount: number) => {
  return `<li class="tags__projects-item tags__projects-item--more">и&nbsp;ещё +${amount}</li>`;
};

export const getConfirmModalTemplate = (): string => {
  return `<div class="popup popup--confirm popup--show">
        <div class="popup__content">
            <h2 class="popup__title">Удалить группу меток?</h2>
            <button class="popup__button button button--trans js-confirm-remove" type="button">Да</button>
            <button class="popup__button button button--submit js-close" type="button">Отмена</button>
        </div>
    </div>`;
};

export const getCreateTagModal = (groupId: number): string => {
  return `<div class="popup js-create-tag-popup popup--show">
  <form method="post" action="/marker/create-marker" class="popup__content popup__content--tags form">
    <button class="popup__close js-close" aria-label="Закрыть окно" type="button"></button>
    <p class="popup__title">Создайте метку</p>
    <fieldset class="form__fieldset">
      <legend class="form__legend">Название</legend>
      <label class="form__label">
        <input type="text" name="tag-name" placeholder="Например «Горящие»" class="form__input">
        <span class="visually-hidden">Название метки</span>
      </label>
      <label class="visually-hidden">
        <input type="hidden" name="group-id" value="${groupId}">
        <span class="visually-hidden">Идентификатор группы меток</span>
      </label>
    </fieldset>
    <fieldset class="form__fieldset">
      <legend class="form__legend">Цвет</legend>
      <div class="form__color-wrap">
        ${tagColors.map(({name, hex}) => {
          return `<label class="form__label">
          <input type="radio" name="tag-color" class="form__color-radio visually-hidden" title="${name}" value="${hex}">
          <span class="form__color-box" style="background-color:${hex};"></span>
          <span class="visually-hidden">${name}</span>
        </label>`
        }).join('')}
      </div>
    </fieldset>
    <div class="form__btn-box">
      <p class="form__error-hint">Введите название и&nbsp;выберите цвет</p>
      <button class="form__button button button--submit" type="submit">Создать метку</button>
      <button class="form__button button button--trans js-close" type="button">Отменить</button>
    </div>
  </form>
</div>`;
};

export const getUpdateTagModal = ({tagId, name, color}: {tagId: number, name: string, color: string}): string => {
  console.log({tagId, name, color});
  return `<div class="popup js-update-tag-popup popup--show">
  <form method="post" action="/marker/update-marker" class="popup__content popup__content--tags form">
    <button class="popup__close js-close" aria-label="Закрыть окно" type="button"></button>
    <p class="popup__title">Отредактируйте метку</p>
    <fieldset class="form__fieldset">
      <legend class="form__legend">Название</legend>
      <label class="form__label">
        <input type="text" name="tag-name" placeholder="Например «Горящие»" class="form__input" value="${name}">
        <span class="visually-hidden">Название метки</span>
      </label>
      <label class="visually-hidden">
        <input type="hidden" name="group-id" value="${tagId}">
        <span class="visually-hidden">Идентификатор группы меток</span>
      </label>
    </fieldset>
    <fieldset class="form__fieldset">
      <legend class="form__legend">Цвет</legend>
      <div class="form__color-wrap">
        ${tagColors.map(({name, hex}) => {
          return `<label class="form__label">
                <input type="radio" name="tag-color" class="form__color-radio visually-hidden" title="${name}" value="${hex}" ${color.toLowerCase() === hex.toLowerCase() ? 'checked' : ''}>
                <span class="form__color-box" style="background-color:${hex};"></span>
                <span class="visually-hidden">${name}</span>
              </label>`
        }).join('')}
      </div>
    </fieldset>
    <div class="form__btn-box">
      <p class="form__error-hint">Введите название и&nbsp;выберите цвет</p>
      <button class="form__button button button--submit" type="submit">Сохранить метку</button>
      <button class="form__button button button--trans js-close" type="button">Отменить</button>
    </div>
  </form>
</div>`;
};

export const getEditProjectModal = (projects: Array<Object>, groupId: number, currentActiveProjects: Array<HTMLLIElement>): string => {
  return `<div class="popup popup--edit-project popup--show">
  <form action="/marker/edit-projects" method="post" class="popup__content popup__content--edit-projects form">
    <button class="popup__close js-close" aria-label="Закрыть окно" type="button"></button>
    <label class="visually-hidden">
      <input type="hidden" name="group-id" value="${groupId}">
      <span class="visually-hidden">Идентификатор группы меток</span>
    </label>
    <div class="popup__title">Проекты группы</div>
    <ul class="popup__project-tags js-project-list">${currentActiveProjects
      .map((project) => getProjectTagTemplate(project.dataset.id, project.textContent))
      .join(``)}</ul>

    <div class="popup__projects-wrap">
      <div class="popup__head">
        <h3 class="popup__subtitle">Список проектов</h3>
        <label class="form__checkbox checkbox">
          <input type="checkbox" name="check-all" value="check-all" class="checkbox__input visually-hidden js-check-all">
          <span class="checkbox__label">Привязать ко&nbsp;всем проектам</span>
        </label>
      </div>
      <label class="form__label">
        <input type="search" placeholder="Название проекта" class="form__input form__input--gray js-search-field">
        <span class="visually-hidden">Название проекта</span>
        <span role="button" class="form__search-reset js-reset-btn" aria-label="Сбросить поиск"></span>
      </label>
      <div class="popup__list list js-project-list">
        ${getProjectsTemplate(projects)}
      </div>
      <div class="form__btn-box">
        <button class="form__button button button--submit" type="submit">Сохранить</button>
        <button class="form__button button button--trans js-close" type="button">Отменить</button>
      </div>
    </div>
  </form>
</div>`;
};

const getProjectsTemplate = (projects: Array<Object>): string => {
  return `${projects
    .map(
      (item: {groupName: string; projects: Array<object>}): string =>
        `<h4 class="list__title">${item.groupName}</h4>
    <ul class="list__wrap">
          ${item.projects
            .map(
              (project: {name: string; id: number}): string =>
                `<li class="list__item" data-name="${project.name}">
          <label class="list__label">
            <input type="checkbox" class="list__checkbox visually-hidden" name="projects[]" value="${project.id}" data-name="${project.name}">
            <span class="list__checkbox-name">${project.name}</span>
          </label>
      </li>`,
            )
            .join(``)}
    </ul>`,
    )
    .join(``)}`;
};

export const getTagsTemplate = (items) => {
  return `<div class="modal__list modal__list--tags">
  ${items
    .map((item) => {
      return `<h3 class="modal__title modal__title--line">${item.groupName}</h3>
    ${getTagsInModalTemplate(item.markers)}`;
    })
    .join(``)}
  </div>`;
};

const getTagsInModalTemplate = (markers) => {
  return `<ul class="modal__sublist modal__sublist--tags">${markers
    .map(
      (marker: {name: string; id: number; color: string}): string =>
        `<li tabindex="0" class="tag tag--hover tag--slim js-tag" data-type="create-task" data-id="${marker.id}" style="background-color:${marker.color};" data-color="${marker.color}">${marker.name}</li>`,
    )
    .join(``)}
  </ul>`;
};

export const getDefaultTemplate = (): string => {
  return `<section class="tags__section ${DEFAULT_TEMPLATE_CLASS_NAME}">
          <h3 class="tags__title tags__title--empty">У&nbsp;вас пока что нет меток</h3>
          <p class="tags__text">Метки помогают структуризировать задачи и&nbsp;делают работу эффективней.</p>
        </section>`;
};

export const getEmptyGroupTemplate = () => {
  return `<section class="tags__section">
          <h2 class="visually-hidden">Введите название группы</h2>
          <form>
            <label class="tags__label">
              <input type="text" class="tags__name-input" placeholder="Введите название группы">
              <span class="visually-hidden">Введите название группы</span>
            </label>
            <div class="tags__footer">
              <button type="submit" class="tags__button button button--submit">Сохранить</button>
              <button type="button" class="tags__button button button--trans js-remove">Отменить</button>
            </div>
          </form>
        </section>`;
};

export const getNewGroupTemplate = (name: string, id: string) => {
  return `<section class="tags__section js-tag-section" data-id="${id}">
          <button type="button" class="tags__remove js-remove-group" aria-label="Удалить группу меток">
            <svg class="tags__remove-icon" width="20" height="20">
              <use xlink:href="/img/sprite.svg#trash-icon"></use>
            </svg>
          </button>
          <h3 class="tags__title js-group-rename" contenteditable="true">${name}</h3>
          <ul class="tags__list js-tag-list"></ul>
          <button class="tags__add add js-create-tag" type="button"><span class="add__text">Создать
              метку</span></button>
          <div class="tags__projects">
            <ul class="tags__projects-list js-project-list"></ul>
            <button class="tags__edit js-edit-projects" type="button">Редактировать</button>
          </div>
        </section>`;
};
